import axios from 'axios';

import { getAuthHeaders } from '@/context';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add interceptors if needed (e.g., for auth tokens)
api.interceptors.request.use(
  (config) => {
    const headers = getAuthHeaders();
    Object.assign(config.headers, headers);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
